module.exports = __webpack_public_path__ + "img/oak-model-sample15-plot.d3116b51.png";